import { MediaFileType, MediaType } from '../../models/media.models';
import { PdfColorIcon, ZipColorIcon, DocColorIcon, DocxColorIcon, ExcelColorIcon, TxtColorIcon, PptColorIcon, MediaDefalutColorIcon, ImageColorIcon, VideoColorIcon, AudioColorIcon } from '../../icon';

interface Props {
    FileName: string;
}
export const DisplayMediaIcon = (props: Props) => {
    let type = props.FileName.substring(props.FileName.lastIndexOf(".")).slice(1)

    const getIcon = () => {

        switch (type) {
            case MediaFileType.PDF:
                return <PdfColorIcon />
            case MediaFileType.ZIP:
                return <ZipColorIcon />
            case MediaFileType.DOC:
                return <DocColorIcon />
            case MediaFileType.DOCX:
                return <DocxColorIcon />
            case MediaFileType.XLSX:
                return <ExcelColorIcon />
            case MediaFileType.TXT:
                return <TxtColorIcon />
            case MediaFileType.PPT:
                return <PptColorIcon />
            case MediaType.IMAGE:
            case MediaType.IMAGE_GIF.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
            case MediaType.IMAGE_JPEG.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
            case MediaType.IMAGE_ARW.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
            case MediaType.IMAGE_PNG.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
            case MediaType.IMAGE_WEBP.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
            case MediaType.IMAGE_TIFF.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
            case MediaType.IMAGE_JPG.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
                return <ImageColorIcon />

            case MediaType.VIDEO:
            case MediaType.VIDEO_MP4.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
                return <VideoColorIcon />
            case MediaType.AUDIO:
            case MediaType.AUDIO_MP3.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
            case MediaType.AUDIO_MPeg.substring(MediaType.IMAGE_JPG.indexOf("/")).slice(1):
                return <AudioColorIcon />
            default:
                return <MediaDefalutColorIcon />

        }
    }
    return (
        <div>{getIcon()}</div>
    )

};